import React, { useState, useEffect, useRef } from 'react'
import { Menu } from 'antd';
import { UserOutlined, TagOutlined, TagsOutlined, CalculatorOutlined, SettingOutlined, BlockOutlined, SolutionOutlined, ReadOutlined, FileUnknownOutlined, ClusterOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './left.css';
import _axios from '../../unit/axios';

export default function Left() {

    const menus = [{
        key: 'space', icon: <ClusterOutlined />, label: '统计首页',
    },{
        key: 'user', icon: <UserOutlined />, label: '学生账号',
    }, {
        key: 'cate1', icon: <TagOutlined />, label: '题库一级分类',
    }, {
        key: 'cate2', icon: <TagsOutlined />, label: '题库二级分类',
    }, {
        key: 'question', icon: <CalculatorOutlined />, label: '题目管理',
    }, {
        key: 'answer', icon: <FileUnknownOutlined />, label: '答案管理',
    }, {
        key: 'score', icon: <BlockOutlined />, label: '成绩管理',
    }, {
        key: 'school', icon: <ReadOutlined />, label: '学校管理',
    }, {
        key: 'student', icon: <SolutionOutlined />, label: '学生管理',
    }, {
        key: 'setting', icon: <SettingOutlined />, label: '系统设置',
        children: [{
            key: 'account', label: '账号管理',
        }, {
            key: 'auth', label: '权限管理',
        }]
    }, ]

    const [authMenus, setAuthMenus] = useState([]);

    let isinit = false;
    useEffect(() => {
        if (!isinit) {
            var user = JSON.parse(localStorage.getItem('user'));
            if (user.id == '3') { 
                setAuthMenus(menus);
                checkMenu();
            } else {
                getRole(user.role);
            }
            isinit = true;
        }
        
    }, [])

    const auths = useRef([]);
    const getRole = (id) => {
        var p = {
            id,
        }
        _axios.get('/api.v1/role/info', { params: p }).then(res => {
            auths.current = JSON.parse(res.data.rule || '');
            localStorage.setItem('auth', JSON.stringify(auths.current))
            setMenu();
        }).catch(err => {
            console.log(err)
        })
    }
    
    const setMenu = () => {
        var tempMenu = [];
        var hasSetting = [];
        for (var m of menus) {
            var hasAuth = false;
            for (var auth of auths.current) {
                var cate = auth.indexOf('-') > 0 ? auth.split('-')[0] : auth;
                if (['account', 'auth'].includes(cate)) {
                    hasSetting.push(cate)
                }
                if (m.key == cate) {
                    hasAuth = true;
                    break;
                }
            }
            if (hasAuth) {
                tempMenu.push(m);
            }
        }
        hasSetting = Array.from(new Set(hasSetting));
        if (hasSetting.length) {
            for (var m of menus) {
                if (m.key == 'setting') {
                    console.log(m)
                    m.children.filter((item) => {
                        if (hasSetting.includes(item.key)) {
                            return item;
                        }
                    })
                    tempMenu.push(m);
                    break;
                }
            }
        }
        setAuthMenus(tempMenu);
        checkMenu();
    }

    const checkMenu = () => {
        const path = window.location.pathname.split('/')[2];
        setActiveKey([path]);
    }

    const [activeKey, setActiveKey] = useState([]);

   
    const navigate = useNavigate();
    const menuSelect = (item) => {
        navigate(`/page/${item.key}`);
        checkMenu();
    }

    return (
        <div style={{ width: '280px', borderRight: '2px solid #12285d', padding: '10px', background: 'rgb(6,12,64)', }}>
            {activeKey}
            <Menu selectedKeys={activeKey} mode="inline" theme="dark" items={authMenus} onSelect={menuSelect} className="menupapa" defaultOpenKeys={['setting']} />

        </div>
    )
}
